package com.nonopn.skywatcher.design.local

import androidx.compose.runtime.compositionLocalOf
import com.nonopn.skywatcher.design.theme.FontSizes

val LocalFontSizes = compositionLocalOf<FontSizes> { error("No LocalFontSizes") }
